if(window.matchMedia('(max-width: 480px)').matches) {
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.querySelectorAll('.cm-reservision').forEach(reservision => {
      reservision.addEventListener('click', e => {
        dialog.close()
      })
    })
  })
}